module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }